import { buildCollection } from "@firecms/core";
import { PhotoUrlField } from "./profile";

export const userCollection = buildCollection({
    id: "user",
    name: "Users",
    icon: "person",
    description: "Manage system users and their onboarded status.",
    path: "user",
    defaultSize: "m",
    openEntityMode: "full_screen",
    customId: false,
    permissions: {
        edit: true,
        create: false,
        delete: false
    },
    propertiesOrder: [
        "display_name",
        "photo_url",
        "email",
        "onboarded",
        "created_time",
        "resume_ref",
        "uid",
        "created_at",
        "updated_at"
    ],
    properties: {
        created_at: {
            dataType: "date",
            name: "Created at",
            autoValue: "on_create"
        },
        updated_at: {
            dataType: "date",
            name: "Updated at",
            autoValue: "on_update"
        },
        uid: {
            dataType: "string",
            name: "UID",
            readOnly: true
        },
        display_name: {
            dataType: "string",
            name: "Display Name",
            validation: { required: true }
        },
        photo_url: {
            dataType: "string",
            name: "Photo URL",
            Field: PhotoUrlField,
            hideFromCollection: true
        },
        email: {
            dataType: "string",
            name: "Email",
            validation: { 
                required: true,
                matches: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                matchesMessage: "Please enter a valid email address"
            }
        },
        onboarded: {
            dataType: "boolean",
            name: "Onboarded"
        },
        created_time: {
            dataType: "date",
            name: "Created Time"
        },
        resume_ref: {
            dataType: "reference",
            path: "resume",
            name: "Resume Reference"
        }
    }
});
